import React from 'react'
import { useNavigate } from 'react-router-dom'
import { CaseDetail, MergedCaseApiData } from '../../../../models/CaseDetail'
import { colors } from '../../../../theme/palette'
import { Button } from '../../../ui/Button/Button'
import { Typography } from '../../../ui/Typography/Typography'
import { formatDate } from '../../../../utils/format'
import { useMergedCasesStyles } from './MergedCasesOverlay'
import { RemoveMergedCase } from './RemoveMergedCase'
import { L } from '../../../providers/Lokalise'
import { Tooltip } from '../../../ui/Tooltip/Tooltip'

export const MergedCaseCard = ({
    mergedCase,
    caseDetails,
    onUpdated,
}: {
    mergedCase: MergedCaseApiData
    caseDetails: CaseDetail
    onUpdated?: () => void
}): JSX.Element => {
    const classes = useMergedCasesStyles()
    const navigate = useNavigate()

    return (
        <>
            <div
                style={{
                    display: 'flex',
                    position: 'relative',
                    gap: '1rem',
                    border: `1px solid ${colors.green}`,
                    padding: '0.5rem',
                    borderRadius: '0.5rem',
                    flexDirection: 'column',
                }}
            >
                <Button
                    type="ghost"
                    onClick={() => {
                        navigate(
                            `/mine-lonindplaceringer/sag/${mergedCase.sagsId}`
                        )
                    }}
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '.6rem',
                        alignItems: 'flex-start',
                    }}
                >
                    <div>
                        <Typography
                            tag="h3"
                            size="XS"
                            spacing=".2rem"
                            weight="bold"
                        >
                            {mergedCase.nyansatteNavn}
                        </Typography>
                    </div>
                    <div
                        style={{
                            display: 'flex',
                            gap: '2rem',
                        }}
                    >
                        <Typography
                            tag="h3"
                            size="XXS"
                            spacing=".2rem"
                            color={colors.gray900}
                        >
                            {mergedCase.sagsNr}
                        </Typography>
                        <Typography
                            tag="h3"
                            size="XXS"
                            spacing=".2rem"
                            color={colors.gray900}
                        >
                            <span>
                                {`${L(
                                    'LØN_SAMMENLÆG_SAG_AUTOCOMPLETE_MODTAGET_DATO'
                                )} ${formatDate(
                                    new Date(mergedCase.modtagetDato)
                                )}`}
                            </span>
                        </Typography>
                    </div>

                    <div>
                        <Typography
                            tag="h3"
                            size="XXS"
                            spacing=".2rem"
                            color={colors.gray900}
                        >
                            {`${L('LØN_OVERSIGT_SAMMENLAG_SAG_STATUS')}: ${
                                mergedCase.sagStatus.statusNavn
                            }`}
                        </Typography>
                    </div>
                </Button>
                {caseDetails.allowedUpdateActionList.includes(
                    'FjernSammenfletMedAndenSag'
                ) && (
                    <Tooltip
                        content={L('LØN_FJERN_SAMMENLAGT_SAG_DIALOG_KNAP_TEXT')}
                    >
                        <div className={classes.actions}>
                            <RemoveMergedCase
                                currentCase={caseDetails}
                                otherCase={mergedCase}
                                onSuccess={() => {
                                    onUpdated?.()
                                }}
                            />
                        </div>
                    </Tooltip>
                )}
            </div>
        </>
    )
}
